import { Assignment } from "@material-ui/icons";
import React from "react";
import { SpeedOutlined, Dashboard, Assessment } from "@material-ui/icons";
import {
  Book,
  MoreHorizontal,
  FileText,
  PieChart,
  Home,
  Edit,
  Percent,
} from "react-feather";
//mport {} from '@material-ui/icons/';

const iconos = {
  ctl: Book,
  ctlPnlsol: FileText,
  indicador: PieChart,
  inicio: Home,
  reportes: Assignment,
  ptareas: Edit,
  progreso: Percent,
  dsh: SpeedOutlined,
  tableroList: Dashboard,
  tableroSeg: Assessment,
};
export default (paginasUsuario) => {
  let paginas = [{
    id_pagina: "inicio",
    title: "Inicio",
    icon: Home,
    href: "/",
  }];
  let existTableros = paginasUsuario.find(
    (paginas) => paginas.rutaPadre == "tableroList"
  );
  if (!existTableros && paginas)
    paginas.push({
      id_pagina: "tableroList",
      title: "Tableros",
      icon: Dashboard,
      href: "/",
      children: [],
    });
  paginasUsuario
    .filter((pg) => pg.visible == 1 && pg.idpagina !== "inicio")
    .forEach((pagina) => {
      if (pagina.idPadre) {
        let indicePagina = paginas
          .map((pagina) => pagina.id_pagina)
          .indexOf(pagina.idPadre);
        if (indicePagina >= 0)
          paginas[indicePagina].children.push({
            id_pagina: pagina.idpagina,
            title: pagina.npagina,
            icon: MoreHorizontal,
            href: pagina.raiz == 0 ? pagina.rutaPadre + pagina.ruta : "/",
          });
        else
          paginas.push({
            id_pagina: pagina.idPadre,
            title: pagina.ncategoria,
            icon: iconos[pagina.idPadre],
            href: pagina.raiz == 0 ? pagina.rutaPadre : "/",
            children: [
              {
                id_pagina: pagina.idpagina,
                title: pagina.npagina,
                icon: MoreHorizontal,
                href: pagina.raiz == 0 ? pagina.rutaPadre + pagina.ruta : "/",
              },
            ],
          });
      } else
        paginas.push({
          id_pagina: pagina.idpagina,
          title: pagina.npagina,
          icon: iconos[pagina.idpagina],
          href: pagina.raiz == 0 ? pagina.ruta : "/",
        });
    });
  return paginas;
};
